// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"69":"c16184b3","245":"component---src-pages-index-tsx"}[chunkId] || chunkId) + "-" + {"69":"72398aac678bedd69521","108":"59cb0ba308246db6e221","245":"cf718daeffa5d9763b35","452":"f544dd5d8da2b662a80d"}[chunkId] + ".js";
};